<div class="d-flex align-items-center h-100">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-8">
        <div class="clearfix">
          <ng-container *ngIf="!isFirstCheck; else checkingSystemStatus">
            <h1 class="float-start display-3 me-4">503</h1>
            <h4 class="pt-3">Maintenance</h4>
            <p class="text-muted">
              The site is down for maintenance. <br />Please contact
              <a href="mailto:team@enin.ai">team&#64;enin.ai</a> if you have any questions.
            </p>
            <div>
              <button class="btn btn-outline-primary" [disabled]="isLoading" (click)="navigateBack()">
                Try again <i [hidden]="isLoading" class="fa fa-refresh"></i>
                <i [hidden]="!isLoading" class="fa fa-spinner fa-spin"></i>
              </button>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #checkingSystemStatus>
  <h4 class="pt-3">Checking system status <i class="fa fa-spinner fa-spin"></i></h4>
</ng-template>
